'use strict';

const any = require('../../rlink-shapes/any');
const instanceOf = require('../../rlink-shapes/instanceOf');
const objectOf = require('../../rlink-shapes/objectOf');
const shape = require('../../rlink-shapes/shape');
const { bool, number, object } = require('../../rlink-shapes/primitives');
const { makeShapeTemplate } = require('../../rlink-collections/');

const CACHES_SHAPE = makeShapeTemplate(
  objectOf(shape({
    DATA: objectOf(shape({
      timestamp: instanceOf(Date),
      reference: any,
      resolved: any,
      meta: object,
      updates: object,
      updatedBy: object,
    })).isRequired,
    REQUESTS: objectOf(shape({
      timestamp: instanceOf(Date),
      hasData: bool,
      pending: bool,
      cancelled: bool,
      timeoutId: number,
      error: any,
      reference: any,
      resolved: any,
      meta: object,
      updates: object,
      updatedBy: object,
    })).isRequired,
  })).isRequired
);

module.exports = CACHES_SHAPE;



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/CACHES_SHAPE.js